import { render, staticRenderFns } from "./FilesAgent.vue?vue&type=template&id=6014bd64"
import script from "./FilesAgent.vue?vue&type=script&lang=js"
export * from "./FilesAgent.vue?vue&type=script&lang=js"
import style0 from "./FilesAgent.vue?vue&type=style&index=0&id=6014bd64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports